import * as types from '../actions/action-types';

const defaults = {
  player: {
    id: 8471699,
    teamId: 24,
    team: {id: 24, name: "Anaheim Ducks", nick: "Ducks", abbr: "ANA"},
    name: "Andrew Cogliano",
    sweater: "7"
  },
  shotType:'bins',
  shotsMinimum:1,
  shotsFiltered: false,
  color: '#2980b9'
};

export default (store = defaults, action) => {
  switch (action.type) {
    case types.SELECT_PLAYER:
      return {...store, player:action.player};
    case types.SELECT_SHOT_TYPE:
      return {...store, shotType:action.shotType};
    case types.SELECT_SHOTS_FILTERED:
      return {...store, shotsFiltered:action.shotsFiltered};
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/selections-reducer.js